import { useProductRefreshAlphaEnabled } from '../product_refresh/useProductRefreshAlphaEnabled'
import { useProductRefreshBetaGate } from '../product_refresh/useProductRefreshBetaGate'
import { useProductRefreshGlobalBetaEnabled } from '../product_refresh/useProductRefreshGlobalBetaEnabled'
import { useProductRefreshGlobalOptInDisabled } from '../product_refresh/useProductRefreshGlobalOptInDisabled'
import { useProductRefreshUserOptIn } from '../product_refresh/useProductRefreshUserOptIn'

/**
 * Early-access banner visibility:
 * - Beta cohort (`ap_product_refresh_2026_global`): show until the user opts in, even when alpha
 *   flags / preview are active, unless `ap_product_refresh_2026_global_opt_in_disabled` forces refresh.
 * - Alpha cohort (any `ap_rebrand_*` flag): show until the beta gate opens (opt-in or dev preview).
 */
export function useBrandRefreshBetaEligibility(): boolean {
  const hasGlobalBeta = useProductRefreshGlobalBetaEnabled()
  const optInDisabled = useProductRefreshGlobalOptInDisabled()
  const userOptedIn = useProductRefreshUserOptIn()
  const isAlpha = useProductRefreshAlphaEnabled()
  const betaGateOpen = useProductRefreshBetaGate()

  if (hasGlobalBeta && !userOptedIn && !optInDisabled) {
    return true
  }

  return isAlpha && !betaGateOpen
}
